import { Button, Col, Form, Modal, Row, Tabs, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import Angela1C from './ManagerDashboard/Common/Angela/Angela1C';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import queryString from "query-string";
import { FaTable } from 'react-icons/fa';
import StAddNew from '../pages/DSeries/StAddNew';
import FlameTable from '../pages/InputCreater/FlameTable';
import SparkTable from '../pages/InputCreater/SparkTable';
import KPIColorSetter from './KPIColorSetter';


const DynamicBlock = ({
    label,
    name,
    defaultValue,
    form
}) => {
    const { search } = useLocation();
    const [editModal, setEditModal] = useState({
        open: false,
        params: {},
        type: ''
    });
    const urlParams = queryString.parse(search);
    const [settingForm ] = Form.useForm()
    const LocalDict = [];
    const [blockList, setBlockList] = useState([]);
    const [form1] = Form.useForm();
    const [chartTab, setChartTab] = useState('auto');


    useEffect(() => {
        if (defaultValue) {
            setBlockList(defaultValue);
        }
    }, []);

    useEffect(() => {
        form.setFieldsValue({ [name]: blockList });
    }, [blockList]);


    const addBlock = () => {
        let newdivid = moment().valueOf().toString();
        setBlockList([...blockList, { divid: newdivid, isVirgin: true }])
    };

    const deleteBlock = (divid) => {
        setBlockList(blockList.filter((x) => x.divid !== divid))
    };

    const openEditModal = (type, divid, chartid, isVirgin) => {
        setEditModal({
            open: true,
            params: {
                divid,
                chartid,
                isVirgin
            },
            type
        })
    };

    const cancelEditModal = () => {
        setChartTab('');
        setTimeout(() => {
            setEditModal({
                open: false,
                params: {},
                type: ''
            })
        }, 200);
    };

    return (
        <div className='ant-form-item'>
            <Form.Item hidden name={name} />
            <Row className='ant-form-item-row'>
                <Col span={24} className='ant-form-item-label' style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                    <label className='ant-form-item-no-colon' title={label}>{label}</label>
                    <Button onClick={addBlock} type="primary">Add New</Button>
                </Col>
                <Col span={24} className='ant-form-item-control'>
                    <div style={{ borderRadius: 7, border: '1px solid grey', minHeight: 150, display: 'inline-flex', flexWrap: 'wrap', width: '100%' }}>
                        {
                            blockList.length && (
                                <>
                                    {
                                        blockList.map((item, index) => (
                                            <div className='chart-container dynamic-block' style={{ marginTop: 15, marginBottom: 15, marginLeft: 5, marginRight: 5, padding: 0 }}>
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <Tooltip title="Setting" color="blue">
                                                        <Button
                                                            className='add-new-icon'
                                                            type="link"
                                                            icon={
                                                                <i className="fa fa-gear"></i>
                                                            }
                                                            onClick={() => openEditModal('settings', item.divid, item.chartid, item.isVirgin)}>{''}</Button>
                                                    </Tooltip>
                                                    <Tooltip title="Edit Data" color="green">
                                                        <Button
                                                            className='add-new-icon'
                                                            icon={<FaTable />}
                                                            type="link" onClick={() => {
                                                                setChartTab('auto');
                                                                openEditModal('data', item.divid, item.chartid, item.isVirgin);
                                                            }
                                                            }>{''}</Button>
                                                    </Tooltip>
                                                    <Tooltip title="Delete" color="red">
                                                        <Button
                                                            className='delete-row-icon'
                                                            icon={
                                                                <i className="fa fa-minus-square-o"></i>
                                                            }
                                                            type="link" onClick={() => deleteBlock(item.divid)}>{''}</Button>
                                                    </Tooltip>
                                                </div>
                                                <div key={index} className={item.divid} style={{ paddingRight: 10 }}>
                                                    <Angela1C
                                                        // refreshChart={refreshChart}
                                                        divId={item.divid}
                                                        api={"/insight/charttemplate"}
                                                        urlData={{
                                                            ...urlParams,
                                                            // chartGroup: "ZenChartArsenal",
                                                            divId: item.divid,
                                                            isVirgin: item.isVirgin,
                                                            chartTyp: 'Angela1C_SingleRow'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            )
                        }
                    </div>
                </Col>
            </Row>

            <Modal
                onCancel={cancelEditModal}
                cancelButtonProps={{ hidden: true }}
                okButtonProps={{ hidden: true }}
                title="Edit"
                open={editModal.open}
                width={'45%'}>
                {
                    editModal.type === 'data' && (
                        <>
                            {/* <Radio.Group>
                                <Radio.Button>Auto</Radio.Button>
                                <Radio.Button>Manual</Radio.Button>
                            </Radio.Group> */}
                            <Tabs
                                className='dynamic-charts-tabs'
                                defaultActiveKey={chartTab}
                                onChange={e => setChartTab(e)}
                                type="card"
                                size='medium'
                                items={[
                                    { key: 'auto', label: 'Auto' },
                                    { key: 'manual', label: 'Manual' },
                                ]}
                            />
                            <div className={'customer-complaint'} style={{ padding: "10px" }}>
                                <div className="customer-form">
                                    <Form
                                        form={form1}
                                        labelCol={{ span: 8 }}
                                        layout={"horizontal"}
                                        colon={false}
                                        onFinish={() => { }}
                                        size="large"
                                    >
                                        {
                                            chartTab === 'auto' && (
                                                <div className='phantom-form'>
                                                    <StAddNew
                                                        colSpan={24}
                                                        urlEndpoint={"/smodal"}
                                                        extraData={{
                                                            chartParams: editModal.params,
                                                            pageParams: {
                                                                ...urlParams
                                                            }
                                                        }}
                                                        urlData={{
                                                            dictName: "InsightChartKpi",
                                                            chartParams: JSON.stringify(editModal.params),
                                                            pageParams: JSON.stringify({
                                                                ...urlParams
                                                            }),
                                                            // dictName: 'WhyTable2'
                                                        }}
                                                        onCallFinish={() => {
                                                            cancelEditModal();
                                                            // setRefreshChart(true);
                                                            // setTimeout(() => {
                                                            //     setRefreshChart(false)
                                                            // }, 2000)
                                                        }}
                                                    />
                                                </div>
                                            )
                                        }
                                        {
                                            chartTab === 'manual' && (
                                                <FlameTable
                                                    LocalDict={LocalDict}
                                                    // label={'Spark Table'}
                                                    labelCol={24}
                                                    form={form1}
                                                    api={'/dynamicchart/flametable'}
                                                    params={{
                                                        chartParams: JSON.stringify(editModal.params),
                                                        pageParams: JSON.stringify({
                                                            ...urlParams
                                                        }),
                                                        // dictName: 'WhyTable2'
                                                    }}
                                                    colSpan={24}
                                                //  layoutPosition={layoutPosition}
                                                />
                                            )
                                        }
                                        {
                                            ((editModal.type === 'data') && (chartTab === 'auto')) ? (
                                                <></>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                                                    <Button htmlType='submit' type="primary">Submit</Button>
                                                </div>
                                            )
                                        }
                                    </Form>
                                </div>
                            </div>
                        </>
                    )
                }
                {
                    editModal.type === 'settings' && (
                        <Form
                            labelCol={{ span: 8 }}
                            layout={"horizontal"}
                            form={settingForm}
                            colon={false}
                            onFinish={(values) => { console.log(values) }}
                            size="large"
                        >
                            <KPIColorSetter 
                                name="dynamic_block"
                                form={settingForm}
                            />
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                                <Button htmlType='submit' type="primary">Submit</Button>
                            </div>
                        </Form>
                    )
                }
            </Modal>

        </div>
    )
};

export default DynamicBlock;